// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2CTih","productName":"Table_productName__30bC1"};